// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryItem_wrapper__T1dIA","image":"CategoryItem_image__VlV42","name":"CategoryItem_name__ReZpb"};